import React, { useCallback, useState } from 'react';
import { outgoingInvoicesInput } from '../data/searchFlowText';
import { useSelector } from 'react-redux';
import Navigation from '../components/navigation/navigation';
import i18n from '../../../utils/i18n';
import { withTranslation } from 'react-i18next';
import RadioInput from '../components/searchInputs/radioInput';
import { useNavigate } from 'react-router-dom';

const InvoicesOut = ({ ...props }) => {
  const companyStore = useSelector((state) => state.company_store);
  const [invoiceError, setInvoiceError] = useState(false);
  const navigate = useNavigate();

  const handleNext = useCallback(
    (inc) => {
      console.log('COMPANY TYPE', companyStore.companytype);
      if (
        (companyStore.companytype === 'kiva' ||
          companyStore.companytype === 'singleprimary' ||
          companyStore.companytype === 'singlesecondary' ||
          companyStore.companytype === 'vszja') &&
        companyStore.legalentityfounding === true
      ) {
        navigate('/company/request/reg');
      } else if (
        companyStore.companytype === 'kiva' ||
        companyStore.companytype === 'singleprimary' ||
        companyStore.companytype === 'singlesecondary' ||
        companyStore.companytype === 'vszja'
      ) {
        props.handleNext(3);
      } else {
        props.handleNext(inc);
      }
    },
    [props, companyStore]
  );

  const handleBack = useCallback(
    (decr) => {
      props.handleBack(decr);
    },
    [props]
  );

  return (
    <div className='stepContainer'>
      <div>
        <div className='SFInput'>
          <p className='SFSubTitle'>
            <span className='SFSubTitle'>
              {i18n.t('company.outgoinglabel1')}{' '}
            </span>{' '}
            <span className='questionTracker'>5/7</span>
          </p>
          <p className='SFSubTitleHelper'>
            {i18n.t('company.outgoinginvoicestooltip')}
          </p>
          <RadioInput
            storeID='outgoinginvoices'
            dataText={outgoingInvoicesInput()}
          />
          {invoiceError ? (
            <p
              style={{
                color: 'red',
                fontSize: '12px',
                fontWeight: 'bold',
              }}
            >
              {i18n.t('company.invoiceerrormsg')}
            </p>
          ) : null}
        </div>
      </div>
      <Navigation
        step={12}
        handleBack={() => handleBack()}
        handleNext={() => handleNext()}
        openHelpForm={() => props.openHelpForm()}
        disabledProp={companyStore.outgoinginvoices !== '' ? false : true}
      />
    </div>
  );
};

export default withTranslation()(InvoicesOut);
